import { AfterViewInit, Component, inject, viewChild, ViewContainerRef } from '@angular/core';
import { NotifyService as NotifyService } from './notify.service';

@Component({
  selector: 'app-notify-queue',
  templateUrl: './notify-queue.component.html',
  styleUrls: ['./notify-queue.component.css']
})
export class NotifyQueueComponent implements AfterViewInit {

  private service = inject(NotifyService)

  flow = viewChild.required('flow', {read: ViewContainerRef})

  ngAfterViewInit(): void {
    this.service.container = this.flow()
  }

}
